export default "__VITE_ASSET__7f769b62__"